import * as annotationActions from '../../actions/annotationActions';
import * as chartActionTypes from '../../constants/chart-action-types';
import annotationReducer, { getInitialState } from '../annotation';
import * as utils from './annotations.utils';

const initialState = {
  items: [],
  annotationsChanged: false,
  mustRender: false,
};

function annotationsReducer(state = initialState, action) {
  const { items } = state;
  const { index, payload, stateTree, data, mustCheckSeries } = action;

  // Forwarding control to annotation reducer
  if (action.type.startsWith('annotation/')) {
    const updatedItems = [
      ...items.slice(0, index),
      annotationReducer(items[index], action),
      ...items.slice(index + 1),
    ];
    return utils.updateChart(stateTree, state, updatedItems);
  }

  switch (action.type) {
    case chartActionTypes.DESTROY_CHART:
      return initialState;
    case annotationActions.MUST_RENDER_FALSE:
      return { ...state, mustRender: payload };
    case chartActionTypes.RECEIVE_CHART:
      return utils.fetchAnnotationInfo(state, action);
    case annotationActions.ADD_ANNOTATION: {
      const newAnnotation = getInitialState(stateTree);
      const annotationAdded = [...items, newAnnotation];
      return utils.updateChart(stateTree, state, annotationAdded);
    }
    case annotationActions.REMOVE_ANNOTATION: {
      const annotationRemoved = items.filter((_, i) => i !== index);
      return utils.updateChart(stateTree, state, annotationRemoved);
    }
    case annotationActions.FILTER_ANNOTATIONS: {
      const { firstRowAsNames } = data;
      const offset = firstRowAsNames ? 1 : 0;
      const filteredAnnotations = items
        .map((item) => {
          const catIdx = data.categories.findIndex((category) => category === item.category);
          const seriesIdx = data.series.findIndex((series) => series.name === item.series);

          if (catIdx >= 0 && ((mustCheckSeries && seriesIdx >= 0) || !mustCheckSeries)) {
            // TODO: review logic to avoid mutation inside a `.map` operation
            item.value = data.series[seriesIdx].data[catIdx + offset].y;
            return item;
          }
        })
        .filter((item) => item);
      const annotationsChanged = filteredAnnotations.length !== items.length;
      return utils.updateChart(stateTree, state, filteredAnnotations, annotationsChanged);
    }
    default:
      return state;
  }
}

export default annotationsReducer;
